<div class="lateral-drawer" [ngClass]="classes">
  <div class="lateral-menu--content">
    <span class="back-arrow" (click)="closeDrawer()"  [ngClass]="backArrowForMobile? 'd-md-none' : 'd-none'">
      <sc-icon icon="arrow-left-big" size="1"></sc-icon>
    </span>
    <span (click)="closeDrawer()" class="close-button sc-icon sc-icon--2x icon-close"
    [ngClass]="backArrowForMobile? 'd-none d-md-block' : ''"
      ></span>
    <ng-content></ng-content>
  </div>
</div>